import type { SelfServiceAPI } from 'types';
import type { Options } from '../types';
import api from 'lib/axios/api';
import handleServiceError from '../utils/handleServiceError';

interface Data extends SelfServiceAPI.CreateGuestAmendment.Request {
  bookingId: string;
}

const createGuestAmendment = async (
  { bookingId, email, phoneNumber, qffNumber, businessNumber }: Data,
  options: Options = {},
): Promise<SelfServiceAPI.CreateGuestAmendment.Response> => {
  try {
    const { data } = await api.post(`/bookings/${bookingId}/guest-amendment`, { email, phoneNumber, qffNumber, businessNumber });
    return data;
  } catch (error) {
    handleServiceError(error, {
      operationName: `POST /bookings/${bookingId}/guest-amendment`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default createGuestAmendment;
